/*
================================================================ 
     Copyright (c) 2018-2021 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from 'react';
//import classes from '../../sales/catalog/catalog.module.css'
import classes from '../../pm/component/component.module.css'
import { connect } from 'react-redux';
import Tooltip from "@mui/material/Tooltip";
import { withTranslation } from 'react-i18next'

import currencyFormatter from '../../../helper/currencyFormatter';
import Chip from "@mui/material/Chip";
import Draggable from 'react-draggable';
//import { makeStyles } from '@mui/material/styles';
import { Paper, TableCell, TableContainer, TableBody, TableHead, TablePagination, TableRow } from '@mui/material';
import Table from '@mui/material/Table';
import Input from '../../../component/inputpm';
import Divider from '@mui/material/Divider';
import Box from "@mui/material/Box";
import { withNavigation } from "../../../helper/withNavigation";
import jp from 'jsonpath';

const OfferingComponents = (props) => {
  
const t = props.t;
const [nameSearch, setNameSearch] = useState("");
const [codeSearch, setCodeSearch] = useState("");

useEffect(() => {
  console.log("==== off 1 ====", props.productBucketList)
}, []);

// const useStyles = makeStyles((theme) => ({
//   customToolbar: {
//     minHeight: '30px', // Example: Adjust minimum height
//   },
// }));
// const classTable = useStyles();
// Filter separately by name and featureCode
const filtered = props.prettyJson.filter((item) => {
  const matchesName = item.name
    .toLowerCase()
    .includes(nameSearch.toLowerCase());
  const matchesCode = item.featureCode
    .toLowerCase()
    .includes(codeSearch.toLowerCase());

  return matchesName && matchesCode; // must satisfy both
});

const draggableDialogPaper = (props) => {
  return (
    <Draggable bounds={'parent'} defaultClassName="customReactDraggableComponent" handle="#draggableDialogPaper" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};

const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else {
      return "";
    }
  };

  const formatQuantityRange = (obj) => {
    if (!obj || !obj.range) return "";
    const { type, range } = obj;
    if (type === "Exact" || range.min === range.max) {
      return range.min || range.max || "";
    }
    // Range type
    if (range.min && range.max) {
      return `${range.min}-${range.max}`;
    }
    return range.min || range.max || "";
  };
  
  const getBucketName = (id) => {
    if (id === "PACKAGED_SOLUTION") {
      return t("ALL");
    }
    var selectedBucketDetails = jp.query(
      props.productBucketList,
      '$..[?(@.id=="' + id + '")]',
    );
    if (selectedBucketDetails && selectedBucketDetails.length > 0) {
      return selectedBucketDetails[0].name;
    }
    return "";
  };

  const getDependencyLabel = (chipVal, currentItemName) => {
    const dependerQty = formatQuantityRange(chipVal.quantity);
    const dependeeQty = formatQuantityRange(chipVal.cardinality);
    const dependerName = chipVal.dependerName || getBucketName(chipVal.dependerBucketName);
    const dependencyType = chipVal.dependencyType?.toLowerCase() || "mandatory";
    const prefix = chipVal.dependencyMode === "forEach" ? "For each" : "For every";
    // "For every 3-5 camera, 2 HDD is Mandatory"
    return `${prefix} ${dependerQty || "1"} ${dependerName}, ${dependeeQty} ${currentItemName} is ${dependencyType}`;
  };

return (
  <div>
    <Paper elevation={0}>
          <>
            <div className={classes.searchOuterDiv} style={{ marginTop: '8px' }}>
              <div >
                  <Input
                      size={'small'}
                      variant={'outlined'}
                      placeholder={props.t('NAME')}
                      value={nameSearch}
                      name={"name"}
                      onChange={(e) => setNameSearch(e.target.value)}
                      onKeyDown={(e) => setNameSearch(e.target.value)}
                      divClass={classes.inputClass}
                  />
              </div>

              <div style={{ marginRight: '5px' }}>
                  <Input
                      size={'small'}
                      variant={'outlined'}
                      placeholder={props.t('PRODUCT_CODE')}
                      value={codeSearch}
                      name={"code"}
                      onChange={(e) => setCodeSearch(e.target.value)}
                      onKeyDown={(e) => setCodeSearch(e.target.value)}
                      divClass={classes.inputClass}
                  />
              </div>
            </div>
            
            <div style={{ clear: 'both' }}></div>
          </>
      {filtered.length > 0 ? (
          <Box className="roundCorners" style={{ border: "1px solid lightgrey", marginTop: "1rem" }}>
          <TableContainer>
            <Table className='newGlobalTable' aria-label="simple table">
                <TableHead >
                    <TableRow>
                        {/* the header names will be dynamic too */}
                        <TableCell align="center" className="global-custom-sorting-header" >{props.t('CATEGORY')}</TableCell>
                        <TableCell align="center" className="global-custom-sorting-header" >
                          {props.t('NAME')}
                        </TableCell>
                        <TableCell align="center" className="global-custom-sorting-header">
                          {props.t('PRODUCT_CODE')}
                        </TableCell>
                        <TableCell align="center" className="global-custom-sorting-header">
                          {props.t('PRICE')} ({currencyFormatter('', false)})
                        </TableCell>
                        <TableCell align="center" className="global-custom-sorting-header">
                          {props.t('MINIMUM_PRICE')} ({currencyFormatter('', false)})
                        </TableCell>
                        <TableCell align="center" className="global-custom-sorting-header" style={{ width: "300px" }}>
                          {props.t('APPLICABLE_TO')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filtered.length > 0 ?
                        filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => (
                            <TableRow key={1} style={{ cursor: 'pointer' }} onClick={(e) => props.goToComponent(row)}>
                                <TableCell style={{ wordBreak: "break-word" }}>
                                    {row.componentTypeName ? row.componentTypeName : ''}
                                </TableCell>
                                <TableCell align='' style={{ wordBreak: "break-word" }}>
                                    {row.name ? row.name : ''}
                                </TableCell>
                                <TableCell align=''>
                                    {row.featureCode ? row.featureCode : ''}
                                </TableCell>
                                <TableCell align=''>
                                    {row.price ? row.price : ''} &nbsp; {row.priceType} &nbsp; 
                                    {row.priceType === "NTC"
                                        ? row.priceTenure > 1
                                          ? "(" +
                                          row.priceTenure +
                                          " " +
                                          getPriceTenureUOM(
                                            row.priceTenureUOM,
                                          ) +
                                          "s" +
                                          ")"
                                          : "(" +
                                          row.priceTenure +
                                          getPriceTenureUOM(
                                            row.priceTenureUOM,
                                          ) +
                                          ")"
                                        : ""}
                                      {row.priceType === "RC"
                                        ? row.priceTenure
                                          ? row.priceTenure > 1
                                            ? "(" +
                                            "per " +
                                            row.priceTenure +
                                            " " +
                                            getPriceTenureUOM(
                                              row.priceTenureUOM,
                                            ) +
                                            "s" +
                                            ")"
                                            : "(" +
                                            "per " +
                                            getPriceTenureUOM(
                                              row.priceTenureUOM,
                                            ) +
                                            ")"
                                          : ""
                                        : ""}
                                </TableCell>
                                <TableCell align=''>
                                    {row.minimumPrice ? row.minimumPrice : ''} &nbsp; {row.priceType} &nbsp; 
                                    {row.priceType === "NTC"
                                        ? row.priceTenure > 1
                                          ? "(" +
                                          row.priceTenure +
                                          " " +
                                          getPriceTenureUOM(
                                            row.priceTenureUOM,
                                          ) +
                                          "s" +
                                          ")"
                                          : "(" +
                                          row.priceTenure +
                                          getPriceTenureUOM(
                                            row.priceTenureUOM,
                                          ) +
                                          ")"
                                        : ""}
                                      {row.priceType === "RC"
                                        ? row.priceTenure
                                          ? row.priceTenure > 1
                                            ? "(" +
                                            "per " +
                                            row.priceTenure +
                                            " " +
                                            getPriceTenureUOM(
                                              row.priceTenureUOM,
                                            ) +
                                            "s" +
                                            ")"
                                            : "(" +
                                            "per " +
                                            getPriceTenureUOM(
                                              row.priceTenureUOM,
                                            ) +
                                            ")"
                                          : ""
                                        : ""}
                                </TableCell>
                                <TableCell align=''>
                                  {/* Added dependencies Table */}
                                  {row.chipData &&
                                      row.chipData.map((chipVal, chipIndex) => (
                                            <Tooltip
                                              title={getDependencyLabel(chipVal, row.name)}
                                              // title={
                                              //   "Is " +
                                              //   chipVal.dependencyType +
                                              //   " with " +
                                              //   //getBucketName(chipVal.dependerBucketName) +
                                              //   " " +
                                              //   chipVal.dependerName +
                                              //   (chipVal.dependencyType === "Mandatory"
                                              //     ? ". Quantity "
                                              //     : chipVal.cardinality.range.max
                                              //       ? ". Quantity "
                                              //       : "") +
                                              //   (chipVal.dependencyType === "Mandatory"
                                              //     ? chipVal.cardinality.type === "Exact"
                                              //       ? "Exact: " + chipVal.cardinality.range.min
                                              //       : "Min:" + chipVal.cardinality.range.min + " Max:" + chipVal.cardinality.range.max
                                              //     : chipVal.cardinality.type === "Range" &&
                                              //       chipVal.cardinality.range.max &&
                                              //       chipVal.cardinality.range.min
                                              //       ? "Min:" + chipVal.cardinality.range.min + " Max:" + chipVal.cardinality.range.max
                                              //       : chipVal.cardinality.range.max
                                              //         ? " Exact:" + chipVal.cardinality.range.max
                                              //         : "")
                                              // }
                                            >
                                              <Chip
                                                label={getDependencyLabel(chipVal, row.name)}
                                                // label={
                                                //   "Is " +
                                                //   chipVal.dependencyType +
                                                //   " with " +
                                                //   //getBucketName(chipVal.dependerBucketName) +
                                                //   " " +
                                                //   chipVal.dependerName +
                                                //   (chipVal.dependencyType === "Mandatory"
                                                //     ? ". Quantity "
                                                //     : chipVal.cardinality.range.max
                                                //       ? ". Quantity "
                                                //       : "") +
                                                //   (chipVal.dependencyType === "Mandatory"
                                                //     ? chipVal.cardinality.type === "Exact"
                                                //       ? "Exact: " + chipVal.cardinality.range.min
                                                //       : "Min:" + chipVal.cardinality.range.min + " Max:" + chipVal.cardinality.range.max
                                                //     : chipVal.cardinality.type === "Range" &&
                                                //       chipVal.cardinality.range.max &&
                                                //       chipVal.cardinality.range.min
                                                //       ? "Min:" + chipVal.cardinality.range.min + " Max:" + chipVal.cardinality.range.max
                                                //       : chipVal.cardinality.range.max
                                                //         ? " Exact:" + chipVal.cardinality.range.max
                                                //         : "")
                                                // }
                                                color="primary"
                                                variant="outlined"
                                                style={{ marginBottom: 5, marginRight: 5, maxWidth: "300px" }}
                                                className={"custom-chip-style"}
                                              />
                                            </Tooltip>
                                      ))}
                                  {/* dependencies Table */}
                              </TableCell>
                            </TableRow>
                        ))
                        :
                        <TableRow key={1} style={{ cursor: 'pointer' }}>
                            <TableCell align="center" colSpan={8}>{props.t('NO_PRODUCTS_FOUND')}</TableCell>
                        </TableRow>
                    }

                </TableBody>
            </Table>
          </TableContainer>
          </Box>
      )
      :
      (<>
          <Divider />
          <TableContainer>
              <Table>
                  <TableRow key={1} style={{ cursor: 'pointer' }}>
                      <TableCell align="center" colSpan={8}>{props.t('NO_PRODUCTS_FOUND')}</TableCell>
                  </TableRow>
              </Table>
          </TableContainer>
      </>
      )}
      {props.totalProductCountInOffering > 0 &&
          <div className="global-custom-pagination" style={{ background: 'rgba(196, 196, 196, 0.2)' }}>
              <label style={{ float: 'left', padding: '5px' }}>
                  Total Records: {props.totalProductCountInOffering}
              </label>
              
              {/* Pagination component */}
              <TablePagination
                component="div"
                count={filtered.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 50, 100]}
                showFirstButton showLastButton
                //classes={{ toolbar: classTable.customToolbar }}

              />
              {/* <Pagination
                  component="div"
                  page={page}
                  count={props.totalProductCountInOffering}
                  //onChange={handleChangePage}
                  onPageChange={(e, newPage) => setPage(newPage)}
                  showFirstButton showLastButton
                  rowsPerPage={props.perPage}
                  //rowsPerPageOptions={[10, 50, 100]}
              /> */}

          </div>
      }
    </Paper>
</div >
);
}

const mapStateToProps = state => {
  return {
    userPerms: state.auth.userPerms,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    publicBrowsing: state.auth.publicBrowsing,
    loggedInUserType: state.auth.userLoginType,
    menuPaths: state.auth.menuPaths,
    quoteEnabled: state.auth.quoteEnabled,
    tenantRoles: state.auth.tenantRoles
  }
};

export default connect(
  mapStateToProps,
)(withTranslation("translations")(withNavigation(OfferingComponents)));